// extracted by mini-css-extract-plugin
module.exports = {"success-icon":"Sent_success-icon__RdnHE","group":"Sent_group__1O2fe"};